import React, { useEffect } from 'react';
import { clearAuthentication } from "../utils/auth";

export const LogoutPage = () => {
    useEffect(() => {
        clearAuthentication();
        window.location.href = '/login';
    }, []);

    return null;
};    
